<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode ? $t('surgery.Create-Expense') : $t('surgery.Edit-Expense')
      "
    >
      <!-- <b-card-text>
        <b-row v-if="expenses == 'Hospital Expenses'">
          <b-col md="">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
          </b-col>
        </b-row> -->

      <b-row>
        <b-col md="">
          <b-form-group :label="$t('common.name')" label-for="name">
            <b-form-input
              v-model="EditForm.name"
              :placeholder="$t('common.name')"
            />
            <p class="text-danger mt-1">{{ errorForm.name }}</p>
          </b-form-group>
        </b-col>

        <b-col md="">
          <b-form-group :label="$t('surgery.Doctor')" label-for="Doctor">
            <b-form-select
              v-model="EditForm.doctor_id"
              :options="DoctorList"
              :placeholder="$t('surgery.Doctor')"
            />
            <p class="text-danger mt-1">{{ errorForm.doctor_id }}</p>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mb-2">
        <b-col md="">
          <b-form-checkbox
            id="checkbox-1"
            v-model="currency"
            name="checkbox-1"
            value="USD"
            unchecked-value="IQD"
          >
            {{ $t("common.is-dollar") }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="currency === 'USD'">
        <b-col md="">
          <b-form-group :label="$t('common.Amount-USD')" label-for="USD">
            <b-form-input
              type="number"
              v-model="EditForm.amount_usd"
              :placeholder="$t('common.Amount-USD')"
            />
            <p class="text-danger mt-1">{{ errorForm.amount_usd }}</p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('common.Amount-IQD')" label-for="name">
            {{ formatIQDCurrency(EditForm.amount_usd * exchangeRate) }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="">
          <b-form-group :label="$t('common.Amount-IQD')" label-for="name">
            <b-form-input
              type="number"
              v-model="EditForm.amount_iqd"
              :placeholder="$t('common.Amount-IQD')"
            />
            <p class="text-danger mt-1">{{ errorForm.amount_iqd }}</p>
          </b-form-group>
        </b-col>

        <b-col md="">
          <b-form-group :label="$t('common.Amount-USD')" label-for="name">
            <b-col>
              {{ formatUSDCurrency(EditForm.amount_iqd / exchangeRate) }}
            </b-col>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="">
          <b-form-group :label="$t('common.Date')" label-for="date">
            <datepicker
              v-model="EditForm.date"
              :calendar-button="true"
              :clear-button="true"
              :bootstrap-styling="true"
              class="datebtn2"
              placeholder="YYYY-MM-DD"
            ></datepicker>
          </b-form-group>
          <p class="text-danger mt-1">{{ errorForm.date }}</p>
        </b-col>
        <b-col md="">
          <b-form-group :label="$t('common.Exchange-Rate')" label-for="">
            <b-form-input
              v-model="exchangeRate"
              :readonly="true"
              :diabled="true"
              :placeholder="$t('common.Exchange-Rate')"
              type="number"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="">
          <b-form-group
            :label="$t('common.description')"
            label-for="Description"
          >
            <b-form-textarea
              v-model="EditForm.description"
              :placeholder="$t('common.description')"
              type="textarea"
            />
            <p class="text-danger mt-1">{{ errorForm.description }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <!-- <b-row>
        <b-col
          lg="6"
          sm="6"
          @click="expenses = 'Hospital Expenses'"
          v-if="$store.state.app.permissions.includes('get-hospitalExpense')"
        >
          <b-link @click="expenses = 'Hospital Expenses'" style="cursor: pointer">
            <statistic-card-horizontal
              icon=""
              :statistic="$t('hospital.hospital-expenses')"
              class="modify"
            />
          </b-link>
        </b-col>
        <b-col lg="6" sm="6">
          <b-link @click="expenses = 'Doctors Expenses'" style="cursor: pointer">
            <statistic-card-horizontal
              icon=""
              :statistic="$t('surgery.Doctors-Expenses')"
              class="modify"
          /></b-link>
        </b-col>
      </b-row> -->

    <b-card :title="$t('surgery.Doctors-Expenses')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("surgery.Filter-Expenses") }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="6">
            <b-form-group :label="$t('common.from-date')" label-for="date">
              <b-form-datepicker
                id="example-datepicker"
                v-model="fromDate"
                class="mb-2"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col md="4" cols="6">
            <b-form-group :label="$t('common.to-date')" label-for="date">
              <b-form-datepicker
                id="example-datepicker2"
                v-model="toDate"
                class="mb-2"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-2 mt-1">
          <b-col md="4" cols="6">
            <b-form-group :label="$t('common.amount-iqd-sum')" label-for="name">
              <h3>
                <b-badge variant="primary">{{
                  formatIQDCurrency(sums.amount_iqd_sum)
                }}</b-badge>
              </h3>
            </b-form-group>
          </b-col>
          <b-col md="4" cols="6">
            <b-form-group :label="$t('common.amount-usd-sum')" label-for="name">
              <h3>
                <b-badge variant="primary">{{
                  formatUSDCurrency(sums.amount_usd_sum)
                }}</b-badge>
              </h3>
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <br />
          </b-col>
          <b-col md="4" cols="6">
            <p class="text-muted font-weight-bold">
              {{ $t("common.this-sums-based-on-the-selected-date") }}
            </p>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getDoctorExpensesList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
            <b-button class="mx-2" style="display: none"> </b-button>

            <b-button variant="primary" class="mx-2" v-print="DOCTOR">
              {{ $t("surgery.Print-Doctor-Expenses") }}
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("surgery.Doctors-Expenses") }}</h2>
          <b-button
            variant="primary"
            @click="show(EditForm, 'create')"
            v-if="
              $store.state.app.permissions.includes('store-hospitalExpense')
            "
          >
            {{ $t("surgery.Doctors-Expenses") }}
          </b-button>
        </div>

        <b-table
          :items="doctorData"
          responsive
          :fields="DoctorTableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(amount_iqd)="doctorData">
            <span class="text-nowrap font-weight-bolder">
              {{ formatIQDCurrency(doctorData.item.amount_iqd) }}
            </span>
          </template>
          <template #cell(amount_usd)="doctorData">
            <span class="text-nowrap font-weight-bolder">
              {{ formatUSDCurrency(doctorData.item.amount_usd) }}
            </span>
          </template>
          <template #cell(currency_ex_rate)="data">
            <span class="text-nowrap">
              {{ data.item.currency_ex_rate }}
            </span>
          </template>
          <template #cell(doctor)="doctorData">
            <span class="text-nowrap"> {{ doctorData.item.doctor.name }} </span>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->

              <!-- Dropdown -->
              <ActionsButtons
                deletePerm="delete-hospitalExpense"
                editPerm="update-hospitalExpense"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Hospital Expenses</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getDoctorExpensesList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="doctorDataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
    <IVF :data="data" type="Doctor" :fromDate="fromDate" :toDate="toDate" />
    <Doctor :data="doctorData" :fromDate="fromDate" :toDate="toDate" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Datepicker from "vuejs-datepicker";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const IVF = () => import("@/components/printables/IVF.vue");
const Doctor = () => import("@/components/printables/Doctor.vue");
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";

export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    IVF,
    Doctor,
    BFormSelect,
    BFormDatepicker,
    BBadge,
  },
  data() {
    return {
      take: 1000,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      doctorDataCount: 0,
      data: [],
      doctorData: [],
      EditForm: {
        amount_iqd: "",
        amount_usd: "",
        description: "",
        date: "",
        currency_ex_rate: 0,
        _method: "PUT",
        name: "ahmed",
      },
      createMode: false,
      errorForm: {
        amount_iqd: "",
        amount_usd: "",
        description: "",
        date: "",
      },
      params: {
        form: {},
        path: "",
      },
      DoctorTableColumns: [
        { key: "name", sortable: true, label: this.$t("common.name") },
        { key: "doctor", sortable: true, label: this.$t("surgery.Doctor") },
        {
          key: "amount_iqd",
          sortable: true,
          label: this.$t("common.Amount-IQD"),
        },
        {
          key: "amount_usd",
          sortable: true,
          label: this.$t("common.Amount-USD"),
        },
        {
          key: "description",
          sortable: true,
          label: this.$t("common.description"),
        },
        {
          key: "currency_ex_rate",
          sortable: true,
          label: this.$t("common.Exchange-Rate"),
        },

        {
          key: "date",
          sortable: true,
          label: this.$t("common.Date"),
          thStyle: { width: "150px" },
        },
        // { key: "created_at", sortable: true, label: this.$t("common.created_at") },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      exchangeRate: 0,
      currency: "USD",
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      expenses: "Hospital Expenses",
      IVF: {
        id: "IVF",
      },
      DOCTOR: {
        id: "Doctor",
      },
      DoctorList: [],
      sums: {
        amount_iqd_sum: 0,
        amount_usd_sum: 0,
      },
      fromDate: "",
      toDate: "",
    };
  },
  mounted() {
    const today = new Date();
    this.fromDate = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-01`;
    this.getHospitalExchangeRate();
    this.getDoctorExpensesList();
    this.getDoctorList();
    this.getIvfExchangeRate();
  },
  methods: {
    formatDate(ivfDate) {
      const date = new Date(ivfDate);
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${year}-${month}-${day}`;
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          amount_iqd: "",
          amount_usd: "",
          description: "",
          date: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.name = item.name;
        this.EditForm.id = item.id;
        this.EditForm.amount_iqd = item.amount_iqd;
        this.EditForm.amount_usd = item.amount_usd;
        this.EditForm.description = item.description;
        this.EditForm.date = item.date;
        this.EditForm.doctor_id = item.doctor_id;

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
   

    async getHospitalExchangeRate() {
      this.loading = true;

      let url = `/hospitalExchangeRate?&sort=-created_at`;

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.exchangeRate = this.all_data.data[0].value;
      this.loading = false;
    },
    formatIQDCurrency(value) {
      console.log("value", value);
      // Create a new Intl.NumberFormat object for IQD currency
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IQD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      // Format the value and return it
      return formatter.format(value);
    },
    formatUSDCurrency(value) {
      // Ensure the value is a number and format it to one decimal place
      const formattedValue = Number(value).toFixed(1);

      // Create a new Intl.NumberFormat object for USD currency without cents
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });

      // Format the value and return it
      return formatter.format(formattedValue);
    },

    async getDoctorExpensesList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/hospitalExpense?page=${this.page}&take=${
        this.fromDate ? 1000 : 100
      }&sort=-id&doctor=1&include=doctor`;

      if (this.fromDate) {
        url += `&filter[date-ge]=${this.fromDate}`;
      }
      if (this.toDate) {
        url += `&filter[date-le]=${this.toDate}`;
      }

      await this.getList(url);
      this.doctorDataCount = this.all_data.pagination.total;
      this.sums.amount_iqd_sum = this.all_data.sums.amount_iqd_sum;
      this.sums.amount_usd_sum = this.all_data.sums.amount_usd_sum;
      this.doctorData = this.all_data.data;
      this.loading = false;
    },
    async getDoctorList() {
      let url = `/doctor?take=${this.take}`;

      // if (this.dateFilter) {
      //   url += `&filter[date]=${this.dateFilter}`;
      // }

      await this.getList(url);
      // this.dataCount = this.all_data.total;
      // this.EditForm.doctor_id = this.all_data.data;
      // this.DoctorList = this.all_data.data;

      this.all_data.data.forEach((item) => {
        this.DoctorList.push({
          value: item.id,
          text: item.name,
        });
      });

      // this.loading = false;
    },
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/hospitalExpense/${this.deleteForm.id}`)
        .then((response) => {
          this.getDoctorExpensesList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },

    submitItem() {
      let count = 0;
      this.loading = true;
      this.errorForm.amount_iqd = "";
      this.errorForm.amount_usd = "";
      this.errorForm.description = "";
      this.errorForm.date = "";
      this.errorForm.name = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.amount_iqd && !this.EditForm.amount_usd) {
        count++;
        this.errorForm.amount_iqd = "The amount IQD field is required.";
      }
      if (!this.EditForm.amount_usd && !this.EditForm.amount_iqd) {
        count++;
        this.errorForm.amount_usd = "The amount USD field is required.";
      }
      if (!this.EditForm.description) {
        count++;
        this.errorForm.description = "The description field is required.";
      }
      if (!this.EditForm.date) {
        count++;
        this.errorForm.date = "The date field is required.";
      }

      if (!this.EditForm.name) {
        count++;
        this.errorForm.name = "The name field is required.";
      }

      if (!this.EditForm.doctor_id) {
        count++;
        this.errorForm.doctor_id = "The doctor field is required.";
      }

      console.log("editForm", this.EditForm);
      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.currency === "USD") {
        this.EditForm.amount_iqd = this.EditForm.amount_usd * this.exchangeRate;
      }

      if (this.currency === "IQD") {
        this.EditForm.amount_usd = this.EditForm.amount_iqd / this.exchangeRate;
      }
      this.EditForm.currency_ex_rate = this.exchangeRate;
      this.EditForm.date = this.formatDate(this.EditForm.date);

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/hospitalExpense`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              console.log("this.expenses", this.expenses);
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Success",
                  variant: "success",
                  text: "added successfully",
                },
              });

              this.getDoctorExpensesList();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/hospitalExpense/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;

              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Success",
                  variant: "success",
                  text: "updated successfully",
                },
              });
              this.getDoctorExpensesList();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
